<template>
  <basic-container>
    <avue-crud :option="option"
               :data="data"
               :page.sync="page"
               ref="crud"
               @row-del="rowDel"
               v-model="form"
               :permission="permissionList"
               @row-update="rowUpdate"
               @row-save="rowSave"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @refresh-change="refreshChange"
               @selection-change="selectionChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.health_bpreport_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, submit, remove } from '@/api/health/bpreport'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },

      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '',
            prop: 'id',
            rules: [{
              required: true,
              message: '请输入'
            }]
          },
          {
            label: '用户测量记录的编号',
            prop: 'bpIds',
            rules: [{
              required: true,
              message: '请输入用户测量记录的编号'
            }]
          },
          {
            label: 'appUserId',
            prop: 'wxUserId',
            rules: [{
              required: true,
              message: '请输入appUserId'
            }]
          },
          {
            label: '血压水平级别',
            prop: 'bpLevel',
            rules: [{
              required: true,
              message: '请输入血压水平级别'
            }]
          },
          {
            label: '收缩压数值',
            prop: 'ssy',
            rules: [{
              required: true,
              message: '请输入收缩压数值'
            }]
          },
          {
            label: '收缩压状态1满意2不满意',
            prop: 'ssyStatus',
            rules: [{
              required: true,
              message: '请输入收缩压状态1满意2不满意'
            }]
          },
          {
            label: '收缩压次数',
            prop: 'ssyCount',
            rules: [{
              required: true,
              message: '请输入收缩压次数'
            }]
          },
          {
            label: '收缩压达标率',
            prop: 'ssyRate',
            rules: [{
              required: true,
              message: '请输入收缩压达标率'
            }]
          },
          {
            label: '舒张压数值',
            prop: 'szy',
            rules: [{
              required: true,
              message: '请输入舒张压数值'
            }]
          },
          {
            label: '舒张压状态1满意2不满意',
            prop: 'szyStatus',
            rules: [{
              required: true,
              message: '请输入舒张压状态1满意2不满意'
            }]
          },
          {
            label: '舒张压次数',
            prop: 'szyCount',
            rules: [{
              required: true,
              message: '请输入舒张压次数'
            }]
          },
          {
            label: '舒张压达标率',
            prop: 'szyRate',
            rules: [{
              required: true,
              message: '请输入舒张压达标率'
            }]
          },
          {
            label: '症状说明描述',
            prop: 'zzsm',
            rules: [{
              required: true,
              message: '请输入症状说明描述'
            }]
          },
          {
            label: '疾病风险描述',
            prop: 'jbfx',
            rules: [{
              required: true,
              message: '请输入疾病风险描述'
            }]
          },
          {
            label: '精准评估方案描述',
            prop: 'jzpgfa',
            rules: [{
              required: true,
              message: '请输入精准评估方案描述'
            }]
          },
          {
            label: '精准治疗方案描述',
            prop: 'jzzlfa',
            rules: [{
              required: true,
              message: '请输入精准治疗方案描述'
            }]
          },
          {
            label: '精准管理方案描述',
            prop: 'jzglfa',
            rules: [{
              required: true,
              message: '请输入精准管理方案描述'
            }]
          },
          {
            label: '状态: 0 默认 1 暂存 2 已解读',
            prop: 'status',
            rules: [{
              required: true,
              message: '请输入状态: 0 默认 1 暂存 2 已解读'
            }]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            rules: [{
              required: true,
              message: '请输入创建时间'
            }]
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            rules: [{
              required: true,
              message: '请输入修改时间'
            }]
          },
          {
            label: '乐观锁',
            prop: 'revision',
            rules: [{
              required: true,
              message: '请输入乐观锁'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.permission.health_bpreport_add,
        viewBtn: this.permission.health_bpreport_view,
        delBtn: this.permission.health_bpreport_delete,
        editBtn: this.permission.health_bpreport_edit
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.onLoad(this.page, params)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    refreshChange (data) {
      this.onLoad(this.page, data.searchForm)
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },

    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad (page, params = {}) {
      getList(page.currentPage, page.pageSize, params).then(res => {
        const data = res.data
        this.page.total = data.total
        this.data = data.records
      })
    }
  }
}
</script>
